/* Generated from the Open Peeps build (CC0 1.0, Pablo Stanley). Do not edit by hand; ids must match club-stickers-v1. */
export type OpenPeepCategory = "people" | "faces" | "hair" | "bodies" | "clothes" | "accessories";
export const OPEN_PEEPS: { id: string; label: string; category: OpenPeepCategory }[] = [
  { id: "op-hair-afro", label: "Afro", category: "hair" },
  { id: "op-hair-bangs", label: "Bangs", category: "hair" },
  { id: "op-hair-bangs-2", label: "Bangs 2", category: "hair" },
  { id: "op-hair-bantu-knots", label: "Bantu knots", category: "hair" },
  { id: "op-hair-bear", label: "Bear", category: "hair" },
  { id: "op-hair-bun", label: "Bun", category: "hair" },
  { id: "op-hair-bun-2", label: "Bun 2", category: "hair" },
  { id: "op-hair-buns", label: "Buns", category: "hair" },
  { id: "op-hair-cornrows", label: "Cornrows", category: "hair" },
  { id: "op-hair-cornrows-2", label: "Cornrows 2", category: "hair" },
  { id: "op-hair-dreads-1", label: "Dreads 1", category: "hair" },
  { id: "op-hair-dreads-2", label: "Dreads 2", category: "hair" },
  { id: "op-hair-flat-top", label: "Flat top", category: "hair" },
  { id: "op-hair-flat-top-long", label: "Flat top long", category: "hair" },
  { id: "op-hair-gray-bun", label: "Gray bun", category: "hair" },
  { id: "op-hair-gray-medium", label: "Gray medium", category: "hair" },
  { id: "op-hair-gray-short", label: "Gray short", category: "hair" },
  { id: "op-hair-hat-beanie", label: "Hat beanie", category: "hair" },
  { id: "op-hair-hat-hip", label: "Hat hip", category: "hair" },
  { id: "op-hair-hijab", label: "Hijab", category: "hair" },
  { id: "op-hair-long", label: "Long", category: "hair" },
  { id: "op-hair-long-afro", label: "Long afro", category: "hair" },
  { id: "op-hair-long-bangs", label: "Long bangs", category: "hair" },
  { id: "op-hair-long-curly", label: "Long curly", category: "hair" },
  { id: "op-hair-medium-1", label: "Medium 1", category: "hair" },
  { id: "op-hair-medium-2", label: "Medium 2", category: "hair" },
  { id: "op-hair-medium-3", label: "Medium 3", category: "hair" },
  { id: "op-hair-medium-bangs", label: "Medium bangs", category: "hair" },
  { id: "op-hair-medium-bangs-2", label: "Medium bangs 2", category: "hair" },
  { id: "op-hair-medium-bangs-3", label: "Medium bangs 3", category: "hair" },
  { id: "op-hair-medium-straight", label: "Medium straight", category: "hair" },
  { id: "op-hair-mohawk", label: "Mohawk", category: "hair" },
  { id: "op-hair-mohawk-2", label: "Mohawk 2", category: "hair" },
  { id: "op-hair-no-hair-1", label: "No hair 1", category: "hair" },
  { id: "op-hair-no-hair-2", label: "No hair 2", category: "hair" },
  { id: "op-hair-no-hair-3", label: "No hair 3", category: "hair" },
  { id: "op-hair-pomp", label: "Pomp", category: "hair" },
  { id: "op-hair-shaved-1", label: "Shaved 1", category: "hair" },
  { id: "op-hair-shaved-2", label: "Shaved 2", category: "hair" },
  { id: "op-hair-shaved-3", label: "Shaved 3", category: "hair" },
  { id: "op-hair-short-1", label: "Short 1", category: "hair" },
  { id: "op-hair-short-2", label: "Short 2", category: "hair" },
  { id: "op-hair-short-3", label: "Short 3", category: "hair" },
  { id: "op-hair-short-4", label: "Short 4", category: "hair" },
  { id: "op-hair-short-5", label: "Short 5", category: "hair" },
  { id: "op-hair-turban", label: "Turban", category: "hair" },
  { id: "op-hair-twists", label: "Twists", category: "hair" },
  { id: "op-hair-twists-2", label: "Twists 2", category: "hair" },
  { id: "op-face-angry-with-fang", label: "Angry with fang", category: "faces" },
  { id: "op-face-awe", label: "Awe", category: "faces" },
  { id: "op-face-blank", label: "Blank", category: "faces" },
  { id: "op-face-calm", label: "Calm", category: "faces" },
  { id: "op-face-cheeky", label: "Cheeky", category: "faces" },
  { id: "op-face-concerned", label: "Concerned", category: "faces" },
  { id: "op-face-concerned-fear", label: "Concerned fear", category: "faces" },
  { id: "op-face-contempt", label: "Contempt", category: "faces" },
  { id: "op-face-cute", label: "Cute", category: "faces" },
  { id: "op-face-cyclops", label: "Cyclops", category: "faces" },
  { id: "op-face-driven", label: "Driven", category: "faces" },
  { id: "op-face-eating-happy", label: "Eating happy", category: "faces" },
  { id: "op-face-explaining", label: "Explaining", category: "faces" },
  { id: "op-face-eyes-closed", label: "Eyes closed", category: "faces" },
  { id: "op-face-fear", label: "Fear", category: "faces" },
  { id: "op-face-hectic", label: "Hectic", category: "faces" },
  { id: "op-face-loving-grin-1", label: "Loving grin 1", category: "faces" },
  { id: "op-face-loving-grin-2", label: "Loving grin 2", category: "faces" },
  { id: "op-face-monster", label: "Monster", category: "faces" },
  { id: "op-face-old", label: "Old", category: "faces" },
  { id: "op-face-rage", label: "Rage", category: "faces" },
  { id: "op-face-serious", label: "Serious", category: "faces" },
  { id: "op-face-smile", label: "Smile", category: "faces" },
  { id: "op-face-smile-big", label: "Smile big", category: "faces" },
  { id: "op-face-smile-lol", label: "Smile lol", category: "faces" },
  { id: "op-face-smile-teeth-gap", label: "Smile teeth gap", category: "faces" },
  { id: "op-face-solemn", label: "Solemn", category: "faces" },
  { id: "op-face-suspicious", label: "Suspicious", category: "faces" },
  { id: "op-face-tired", label: "Tired", category: "faces" },
  { id: "op-face-very-angry", label: "Very angry", category: "faces" },
  { id: "op-beard-chin", label: "Chin", category: "hair" },
  { id: "op-beard-full", label: "Full", category: "hair" },
  { id: "op-beard-full-2", label: "Full 2", category: "hair" },
  { id: "op-beard-full-3", label: "Full 3", category: "hair" },
  { id: "op-beard-full-4", label: "Full 4", category: "hair" },
  { id: "op-beard-goatee-1", label: "Goatee 1", category: "hair" },
  { id: "op-beard-goatee-2", label: "Goatee 2", category: "hair" },
  { id: "op-beard-moustache-1", label: "Moustache 1", category: "hair" },
  { id: "op-beard-moustache-2", label: "Moustache 2", category: "hair" },
  { id: "op-beard-moustache-3", label: "Moustache 3", category: "hair" },
  { id: "op-beard-moustache-4", label: "Moustache 4", category: "hair" },
  { id: "op-beard-moustache-5", label: "Moustache 5", category: "hair" },
  { id: "op-beard-moustache-6", label: "Moustache 6", category: "hair" },
  { id: "op-beard-moustache-7", label: "Moustache 7", category: "hair" },
  { id: "op-beard-moustache-8", label: "Moustache 8", category: "hair" },
  { id: "op-beard-moustache-9", label: "Moustache 9", category: "hair" },
  { id: "op-acc-eyepatch", label: "Eyepatch", category: "accessories" },
  { id: "op-acc-glasses", label: "Glasses", category: "accessories" },
  { id: "op-acc-glasses-2", label: "Glasses 2", category: "accessories" },
  { id: "op-acc-glasses-3", label: "Glasses 3", category: "accessories" },
  { id: "op-acc-glasses-4", label: "Glasses 4", category: "accessories" },
  { id: "op-acc-glasses-5", label: "Glasses 5", category: "accessories" },
  { id: "op-acc-sunglasses", label: "Sunglasses", category: "accessories" },
  { id: "op-acc-sunglasses-2", label: "Sunglasses 2", category: "accessories" },
  { id: "op-mask-medical-mask", label: "Medical mask", category: "accessories" },
  { id: "op-mask-respirator", label: "Respirator", category: "accessories" },
  { id: "op-bust-1", label: "Peep 1", category: "people" },
  { id: "op-sitting-1", label: "Sitting 1", category: "bodies" },
  { id: "op-bust-5", label: "Peep 5", category: "people" },
  { id: "op-bust-9", label: "Peep 9", category: "people" },
  { id: "op-bust-10", label: "Peep 10", category: "people" },
  { id: "op-bust-12", label: "Peep 12", category: "people" },
  { id: "op-bust-13", label: "Peep 13", category: "people" },
  { id: "op-bust-14", label: "Peep 14", category: "people" },
  { id: "op-bust-19", label: "Peep 19", category: "people" },
  { id: "op-bust-21", label: "Peep 21", category: "people" },
  { id: "op-bust-22", label: "Peep 22", category: "people" },
  { id: "op-bust-23", label: "Peep 23", category: "people" },
  { id: "op-bust-25", label: "Peep 25", category: "people" },
  { id: "op-bust-35", label: "Peep 35", category: "people" },
  { id: "op-bust-39", label: "Peep 39", category: "people" },
  { id: "op-bust-41", label: "Peep 41", category: "people" },
  { id: "op-bust-42", label: "Peep 42", category: "people" },
  { id: "op-bust-43", label: "Peep 43", category: "people" },
  { id: "op-bust-44", label: "Peep 44", category: "people" },
  { id: "op-bust-45", label: "Peep 45", category: "people" },
  { id: "op-bust-48", label: "Peep 48", category: "people" },
  { id: "op-bust-51", label: "Peep 51", category: "people" },
  { id: "op-bust-52", label: "Peep 52", category: "people" },
  { id: "op-bust-53", label: "Peep 53", category: "people" },
  { id: "op-bust-54", label: "Peep 54", category: "people" },
  { id: "op-bust-55", label: "Peep 55", category: "people" },
  { id: "op-bust-57", label: "Peep 57", category: "people" },
  { id: "op-bust-58", label: "Peep 58", category: "people" },
  { id: "op-bust-60", label: "Peep 60", category: "people" },
  { id: "op-bust-63", label: "Peep 63", category: "people" },
  { id: "op-bust-69", label: "Peep 69", category: "people" },
  { id: "op-bust-70", label: "Peep 70", category: "people" },
  { id: "op-bust-72", label: "Peep 72", category: "people" },
  { id: "op-bust-73", label: "Peep 73", category: "people" },
  { id: "op-bust-75", label: "Peep 75", category: "people" },
  { id: "op-bust-76", label: "Peep 76", category: "people" },
  { id: "op-bust-78", label: "Peep 78", category: "people" },
  { id: "op-bust-80", label: "Peep 80", category: "people" },
  { id: "op-bust-81", label: "Peep 81", category: "people" },
  { id: "op-bust-82", label: "Peep 82", category: "people" },
  { id: "op-bust-84", label: "Peep 84", category: "people" },
  { id: "op-bust-89", label: "Peep 89", category: "people" },
  { id: "op-bust-91", label: "Peep 91", category: "people" },
  { id: "op-bust-93", label: "Peep 93", category: "people" },
  { id: "op-bust-94", label: "Peep 94", category: "people" },
  { id: "op-bust-97", label: "Peep 97", category: "people" },
  { id: "op-bust-99", label: "Peep 99", category: "people" },
  { id: "op-bust-103", label: "Peep 103", category: "people" },
  { id: "op-bust-104", label: "Peep 104", category: "people" },
  { id: "op-bust-105", label: "Peep 105", category: "people" },
  { id: "op-sitting-2", label: "Sitting 2", category: "bodies" },
  { id: "op-sitting-4", label: "Sitting 4", category: "bodies" },
  { id: "op-sitting-5", label: "Sitting 5", category: "bodies" },
  { id: "op-sitting-6", label: "Sitting 6", category: "bodies" },
  { id: "op-sitting-7", label: "Sitting 7", category: "bodies" },
  { id: "op-sitting-9", label: "Sitting 9", category: "bodies" },
  { id: "op-sitting-10", label: "Sitting 10", category: "bodies" },
  { id: "op-sitting-11", label: "Sitting 11", category: "bodies" },
  { id: "op-sitting-12", label: "Sitting 12", category: "bodies" },
  { id: "op-sitting-14", label: "Sitting 14", category: "bodies" },
  { id: "op-sitting-15", label: "Sitting 15", category: "bodies" },
  { id: "op-sitting-17", label: "Sitting 17", category: "bodies" },
  { id: "op-sitting-18", label: "Sitting 18", category: "bodies" },
  { id: "op-standing-1", label: "Standing 1", category: "bodies" },
  { id: "op-standing-2", label: "Standing 2", category: "bodies" },
  { id: "op-standing-3", label: "Standing 3", category: "bodies" },
  { id: "op-standing-4", label: "Standing 4", category: "bodies" },
  { id: "op-standing-5", label: "Standing 5", category: "bodies" },
  { id: "op-standing-6", label: "Standing 6", category: "bodies" },
  { id: "op-standing-7", label: "Standing 7", category: "bodies" },
  { id: "op-standing-8", label: "Standing 8", category: "bodies" },
  { id: "op-standing-10", label: "Standing 10", category: "bodies" },
  { id: "op-standing-9", label: "Standing 9", category: "bodies" },
  { id: "op-standing-11", label: "Standing 11", category: "bodies" },
  { id: "op-standing-12", label: "Standing 12", category: "bodies" },
  { id: "op-standing-13", label: "Standing 13", category: "bodies" },
  { id: "op-standing-14", label: "Standing 14", category: "bodies" },
  { id: "op-standing-15", label: "Standing 15", category: "bodies" },
  { id: "op-standing-16", label: "Standing 16", category: "bodies" },
  { id: "op-standing-17", label: "Standing 17", category: "bodies" },
  { id: "op-standing-18", label: "Standing 18", category: "bodies" },
  { id: "op-standing-19", label: "Standing 19", category: "bodies" },
  { id: "op-standing-20", label: "Standing 20", category: "bodies" },
  { id: "op-standing-21", label: "Standing 21", category: "bodies" },
  { id: "op-standing-22", label: "Standing 22", category: "bodies" },
  { id: "op-standing-23", label: "Standing 23", category: "bodies" },
  { id: "op-standing-24", label: "Standing 24", category: "bodies" },
  { id: "op-standing-25", label: "Standing 25", category: "bodies" },
  { id: "op-standing-26", label: "Standing 26", category: "bodies" },
  { id: "op-standing-27", label: "Standing 27", category: "bodies" },
  { id: "op-standing-28", label: "Standing 28", category: "bodies" },
  { id: "op-standing-29", label: "Standing 29", category: "bodies" },
  { id: "op-standing-30", label: "Standing 30", category: "bodies" },
  { id: "op-bust-100", label: "Peep 100", category: "people" },
  { id: "op-bust-101", label: "Peep 101", category: "people" },
  { id: "op-bust-102", label: "Peep 102", category: "people" },
  { id: "op-bust-11", label: "Peep 11", category: "people" },
  { id: "op-bust-15", label: "Peep 15", category: "people" },
  { id: "op-bust-16", label: "Peep 16", category: "people" },
  { id: "op-bust-17", label: "Peep 17", category: "people" },
  { id: "op-bust-18", label: "Peep 18", category: "people" },
  { id: "op-bust-2", label: "Peep 2", category: "people" },
  { id: "op-bust-20", label: "Peep 20", category: "people" },
  { id: "op-bust-24", label: "Peep 24", category: "people" },
  { id: "op-bust-26", label: "Peep 26", category: "people" },
  { id: "op-bust-27", label: "Peep 27", category: "people" },
  { id: "op-bust-28", label: "Peep 28", category: "people" },
  { id: "op-bust-29", label: "Peep 29", category: "people" },
  { id: "op-bust-3", label: "Peep 3", category: "people" },
  { id: "op-bust-30", label: "Peep 30", category: "people" },
  { id: "op-bust-31", label: "Peep 31", category: "people" },
  { id: "op-bust-32", label: "Peep 32", category: "people" },
  { id: "op-bust-33", label: "Peep 33", category: "people" },
  { id: "op-bust-34", label: "Peep 34", category: "people" },
  { id: "op-bust-36", label: "Peep 36", category: "people" },
  { id: "op-bust-37", label: "Peep 37", category: "people" },
  { id: "op-bust-38", label: "Peep 38", category: "people" },
  { id: "op-bust-4", label: "Peep 4", category: "people" },
  { id: "op-bust-40", label: "Peep 40", category: "people" },
  { id: "op-bust-46", label: "Peep 46", category: "people" },
  { id: "op-bust-47", label: "Peep 47", category: "people" },
  { id: "op-bust-49", label: "Peep 49", category: "people" },
  { id: "op-bust-50", label: "Peep 50", category: "people" },
  { id: "op-bust-56", label: "Peep 56", category: "people" },
  { id: "op-bust-59", label: "Peep 59", category: "people" },
  { id: "op-bust-6", label: "Peep 6", category: "people" },
  { id: "op-bust-61", label: "Peep 61", category: "people" },
  { id: "op-bust-62", label: "Peep 62", category: "people" },
  { id: "op-bust-64", label: "Peep 64", category: "people" },
  { id: "op-bust-65", label: "Peep 65", category: "people" },
  { id: "op-bust-66", label: "Peep 66", category: "people" },
  { id: "op-bust-67", label: "Peep 67", category: "people" },
  { id: "op-bust-68", label: "Peep 68", category: "people" },
  { id: "op-bust-7", label: "Peep 7", category: "people" },
  { id: "op-bust-71", label: "Peep 71", category: "people" },
  { id: "op-bust-74", label: "Peep 74", category: "people" },
  { id: "op-bust-77", label: "Peep 77", category: "people" },
  { id: "op-bust-79", label: "Peep 79", category: "people" },
  { id: "op-bust-8", label: "Peep 8", category: "people" },
  { id: "op-bust-83", label: "Peep 83", category: "people" },
  { id: "op-bust-85", label: "Peep 85", category: "people" },
  { id: "op-bust-86", label: "Peep 86", category: "people" },
  { id: "op-bust-87", label: "Peep 87", category: "people" },
  { id: "op-bust-88", label: "Peep 88", category: "people" },
  { id: "op-bust-90", label: "Peep 90", category: "people" },
  { id: "op-bust-92", label: "Peep 92", category: "people" },
  { id: "op-bust-95", label: "Peep 95", category: "people" },
  { id: "op-bust-96", label: "Peep 96", category: "people" },
  { id: "op-bust-98", label: "Peep 98", category: "people" },
  { id: "op-sitting-13", label: "Sitting 13", category: "bodies" },
  { id: "op-sitting-16", label: "Sitting 16", category: "bodies" },
  { id: "op-sitting-3", label: "Sitting 3", category: "bodies" },
  { id: "op-sitting-8", label: "Sitting 8", category: "bodies" },
  { id: "op-top-blazer-black-tee", label: "Blazer black tee (top)", category: "clothes" },
  { id: "op-top-button-shirt-1", label: "Button shirt 1 (top)", category: "clothes" },
  { id: "op-top-button-shirt-2", label: "Button shirt 2 (top)", category: "clothes" },
  { id: "op-top-coffee", label: "Coffee (top)", category: "clothes" },
  { id: "op-top-device", label: "Device (top)", category: "clothes" },
  { id: "op-top-dress", label: "Dress (top)", category: "clothes" },
  { id: "op-top-explaining", label: "Explaining (top)", category: "clothes" },
  { id: "op-top-fur-jacket", label: "Fur jacket (top)", category: "clothes" },
  { id: "op-top-gaming", label: "Gaming (top)", category: "clothes" },
  { id: "op-top-gym-shirt", label: "Gym shirt (top)", category: "clothes" },
  { id: "op-top-hoodie", label: "Hoodie (top)", category: "clothes" },
  { id: "op-top-killer", label: "Killer (top)", category: "clothes" },
  { id: "op-top-macbook", label: "Macbook (top)", category: "clothes" },
  { id: "op-top-paper", label: "Paper (top)", category: "clothes" },
  { id: "op-top-pointing-up", label: "Pointing up (top)", category: "clothes" },
  { id: "op-top-polka-dot-jacket", label: "Polka dot jacket (top)", category: "clothes" },
  { id: "op-top-polo-and-sweater", label: "Polo and sweater (top)", category: "clothes" },
  { id: "op-top-shirt-and-coat", label: "Shirt and coat (top)", category: "clothes" },
  { id: "op-top-sporty-tee", label: "Sporty tee (top)", category: "clothes" },
  { id: "op-top-striped-pocket-tee", label: "Striped pocket tee (top)", category: "clothes" },
  { id: "op-top-striped-tee", label: "Striped tee (top)", category: "clothes" },
  { id: "op-top-sweater-dots", label: "Sweater dots (top)", category: "clothes" },
  { id: "op-top-sweater", label: "Sweater (top)", category: "clothes" },
  { id: "op-top-tee-1", label: "Tee 1 (top)", category: "clothes" },
  { id: "op-top-tee-2", label: "Tee 2 (top)", category: "clothes" },
  { id: "op-top-tee-arms-crossed", label: "Tee arms crossed (top)", category: "clothes" },
  { id: "op-top-tee-selena", label: "Tee selena (top)", category: "clothes" },
  { id: "op-top-thunder-t-shirt", label: "Thunder t shirt (top)", category: "clothes" },
  { id: "op-top-turtleneck", label: "Turtleneck (top)", category: "clothes" },
  { id: "op-top-whatever", label: "Whatever (top)", category: "clothes" },
  { id: "op-legs-standing-blazer-1", label: "Blazer 1 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-blazer-2", label: "Blazer 2 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-blazer-3", label: "Blazer 3 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-blazer-4", label: "Blazer 4 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-crossed-arms-1", label: "Crossed arms 1 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-crossed-arms-2", label: "Crossed arms 2 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-easing-1", label: "Easing 1 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-easing-2", label: "Easing 2 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-pointing-finger-1", label: "Pointing finger 1 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-pointing-finger-2", label: "Pointing finger 2 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-polka-dots", label: "Polka dots (standing legs)", category: "clothes" },
  { id: "op-legs-standing-resting-1", label: "Resting 1 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-resting-2", label: "Resting 2 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-robot-dance-1", label: "Robot dance 1 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-robot-dance-2", label: "Robot dance 2 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-robot-dance-3", label: "Robot dance 3 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-shirt-1", label: "Shirt 1 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-shirt-2", label: "Shirt 2 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-shirt-3", label: "Shirt 3 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-shirt-4", label: "Shirt 4 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-walking-1", label: "Walking 1 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-walking-2", label: "Walking 2 (standing legs)", category: "clothes" },
  { id: "op-legs-standing-walking-3", label: "Walking 3 (standing legs)", category: "clothes" },
  { id: "op-legs-sitting-bike", label: "Bike (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-closed-legs-1", label: "Closed legs 1 (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-closed-legs-2", label: "Closed legs 2 (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-crossed-legs", label: "Crossed legs (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-hands-back-1", label: "Hands back 1 (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-hands-back-2", label: "Hands back 2 (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-mid-1", label: "Mid 1 (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-mid-2", label: "Mid 2 (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-one-leg-up-1", label: "One leg up 1 (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-one-leg-up-2", label: "One leg up 2 (sitting legs)", category: "clothes" },
  { id: "op-legs-sitting-wheelchair", label: "Wheelchair (sitting legs)", category: "clothes" },
];
